export interface AssignedEnrichedUserDetailValuesModel {
  id?: string;
  userId: string;
  enrichedUserDetailValueId: string;
  enrichedUserDetailId: string;
}
